var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2499 8.00005C15.2499 8.19005 15.1799 8.38005 15.0299 8.53005L11.4799 12.08L13.1199 13.17C13.3099 13.29 13.4299 13.5 13.4499 13.72C13.4699 13.95 13.3899 14.17 13.2299 14.32L10.0299 17.52C9.73994 17.81 9.25994 17.81 8.96994 17.52C8.67994 17.23 8.67994 16.75 8.96994 16.46L11.5199 13.91L9.87994 12.82C9.69994 12.7 9.57994 12.5 9.54994 12.27C9.52994 12.04 9.60994 11.82 9.76994 11.67L13.9699 7.47005C14.2599 7.18005 14.7399 7.18005 15.0299 7.47005C15.1799 7.62005 15.2499 7.81005 15.2499 8.00005Z",
    fill: "#327834"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 8V10C15.25 10.41 14.91 10.75 14.5 10.75C14.09 10.75 13.75 10.41 13.75 10V8.75H12.5C12.09 8.75 11.75 8.41 11.75 8C11.75 7.59 12.09 7.25 12.5 7.25H14.5C14.91 7.25 15.25 7.59 15.25 8Z",
    fill: "#327834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.925815eb043b067eed54bb214b3ed5c2.svg";
export { ForwardRef as ReactComponent };